function edges(start, size) {
    return {
        start,
        center: start + size / 2,
        end: start + size
    };
}
function intervalGap(aStart, aEnd, bStart, bEnd) {
    if (bStart > aEnd) return bStart - aEnd;
    if (aStart > bEnd) return aStart - bEnd;
    return 0;
}
function bestAxisMatch(drag, cand, dragSize, threshold, current) {
    const pairs = [
        {
            delta: cand.start - drag.start,
            guide: cand.start,
            snap: cand.start
        },
        {
            delta: cand.center - drag.center,
            guide: cand.center,
            snap: cand.center - dragSize / 2
        },
        {
            delta: cand.end - drag.end,
            guide: cand.end,
            snap: cand.end - dragSize
        }
    ];
    let best = current;
    for (const pair of pairs){
        if (Math.abs(pair.delta) > threshold) continue;
        if (best === null || Math.abs(pair.delta) < Math.abs(best.delta)) best = pair;
    }
    return best;
}
export function computeHelperLines(input) {
    const { dragging, candidates, thresholdX, thresholdY, proximity } = input;
    const marginX = proximity?.marginX;
    const marginY = proximity?.marginY;
    const dragX = edges(dragging.x, dragging.width);
    const dragY = edges(dragging.y, dragging.height);
    let bestX = null;
    let bestY = null;
    for (const cand of candidates){
        if (cand.id === dragging.id) continue;
        const candX = edges(cand.x, cand.width);
        const candY = edges(cand.y, cand.height);
        const xGap = intervalGap(dragX.start, dragX.end, candX.start, candX.end);
        const yGap = intervalGap(dragY.start, dragY.end, candY.start, candY.end);
        if (marginX === undefined || yGap <= marginX) {
            bestX = bestAxisMatch(dragX, candX, dragging.width, thresholdX, bestX);
        }
        if (marginY === undefined || xGap <= marginY) {
            bestY = bestAxisMatch(dragY, candY, dragging.height, thresholdY, bestY);
        }
    }
    const result = {
        snapPosition: {}
    };
    if (bestX) {
        result.snapPosition.x = bestX.snap;
        result.vertical = bestX.guide;
    }
    if (bestY) {
        result.snapPosition.y = bestY.snap;
        result.horizontal = bestY.guide;
    }
    return result;
}

//# sourceMappingURL=helperLines.js.map